import script from "./request-quotation.vue?vue&type=script&setup=true&lang=js"
export * from "./request-quotation.vue?vue&type=script&setup=true&lang=js"

import "./request-quotation.vue?vue&type=style&index=0&id=0817af48&scoped=true&lang=css"
import "./request-quotation.vue?vue&type=style&index=1&id=0817af48&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0817af48"]])

export default __exports__